module.exports = __webpack_public_path__ + "static/media/google.0ef84cac.svg";